import styled from '@emotion/styled'

/* Styles for Planned Date
 */
export const PlannedWrapper = styled.div`
  border: 1px solid #d4d8dd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  color: #262626;
  line-height: 14px;
  padding: 7px 0;
  position: relative;
  margin-bottom: 15px;
`
export const Header = styled.div`
  width: 160px;
  padding-left: 8px;

  span {
    position: relative;
    z-index: 1;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 160px;
    background-color: #e7f1fd;
  }
`
export const Column = styled.div`
  width: 160px;
  margin-left: 10px;
`
export const Title = styled.div`
  color: #747474;
  font-size: 12px;
  margin-bottom: 6px;
`
export const IconWrapper = styled.div`
  margin-right: 10px;
`

/* Styles for Accelerated Depreciation History
 */

export const AcceleratedTable = styled.div`
  .ant-table-thead > tr > th {
    background: #fafafa;
    white-space: pre-line;
  }

  .depreciation-change {
    background: #def8da;
  }
`
